import { useEditor, useNode } from "@craftjs/core";
import Container from "components/general/Container";
import { Box } from "components/ui";
import React from "react";

// export const PageContainer = ({ background = "white", padding = 20, children, ...props }: any) => {
// 	return <Box {...props}>{children}</Box>;
// };
export const PageContainer = ({ background, padding, children, isMainContainer, ...props }: any) => {
	const { id } = useNode();
	const {
		query: { node },
	} = useEditor();
	const isRoot = node(id).isRoot();
	if (padding === "default") {
		padding = 16;
	}
	if (padding === "small") {
		padding = 8;
	}
	if (padding === "large") {
		padding = 32;
	}
	if (isRoot) {
		return <Box>{children}</Box>;
	}

	return (
		<Box
			{...props}
			style={{
				// margin: 5,
				//   border: 1,
				borderColor: "transparent",
				backgroundColor: "transparent",
				padding: padding,
				display: props.display,
				flexDirection: "column",
				// flex: 1,
				// flexDirection: flexDirection,
				// alignItems: alignItems,
				// justifyContent: justifyContent,
			}}
		>
			<Container sx={{ gap: isRoot ? 47 : 0 }} isMainContainer={isMainContainer}>
				{children}
			</Container>
		</Box>
	);
};
